import React, { useEffect, useState, useContext } from 'react';
import { Box, Typography, Stack, TextField, Button, CircularProgress } from '@mui/material';
import chatApi from '../api/chatApi';
import { AuthContext } from '../auth/AuthContext';

export default function FascicoloChat({ fascicoloId }) {
  const { user } = useContext(AuthContext);
  const [roomId, setRoomId] = useState(null);
  const [messages, setMessages] = useState([]);
  const [newMessage, setNewMessage] = useState('');
  const [loading, setLoading] = useState(true);

useEffect(() => {
  const initChat = async () => {
    try {
      setLoading(true);

      // 1️⃣ recupero o creo la room
      const roomRes = await chatApi.getFascicoloRoom(fascicoloId);
      const rid = roomRes.data.id;
      setRoomId(rid);

      // 2️⃣ carico i messaggi
      const msgRes = await chatApi.getMessages(rid);
      setMessages(msgRes.data.content || []);

    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  if (fascicoloId) {
    initChat();
  }

}, [fascicoloId]);

const fetchMessages = async () => {
  try {
    const res = await chatApi.getMessages(roomId);
    setMessages(res.data || []);
  } catch (err) {
    console.error(err);
  } finally {
    setLoading(false);
  }
};

const sendMessage = async () => {
  if (!newMessage.trim()) return;

  try {
    const formData = new FormData();

    // Il backend si aspetta "data" come RequestPart
    formData.append(
      "data",
      new Blob(
        [JSON.stringify({ content: newMessage })],
        { type: "application/json" }
      )
    );

    const res = await chatApi.sendMessage(roomId, formData);
    //fetchMessages();
    setMessages(prev => [...prev, res.data]);
    setNewMessage('');

  } catch (err) {
    console.error(err);
  }
};

  if(loading) return <CircularProgress />;

  return (
    <Box mt={4} p={2} sx={{ border: '1px solid #ccc', borderRadius: 2 }}>
      <Typography variant="h6" sx={{ mb: 2 }}>Chat Fascicolo</Typography>
      <Stack spacing={1} sx={{ maxHeight: 300, overflowY: 'auto', mb: 2 }}>
        {messages.map(m => (
          <Box key={m.id} sx={{ p: 1, bgcolor: m.authorId === user.id ? '#DCF8C6' : '#F1F0F0', borderRadius: 1 }}>
            <Typography variant="body2">{m.senderRole}</Typography>
            <Typography variant="body2">{m.content}</Typography>
            <Typography variant="caption">{new Date(m.createdAt).toLocaleString()}</Typography>
          </Box>
        ))}
      </Stack>
      <Stack direction="row" spacing={1}>
        <TextField
          fullWidth
          size="small"
          value={newMessage}
          onChange={(e) => setNewMessage(e.target.value)}
          placeholder="Scrivi un messaggio..."
        />
        <Button variant="contained" onClick={sendMessage}>Invia</Button>
      </Stack>
    </Box>
  );
}